import type { TicketVatTreatment } from '@pulsify/shared'
import * as m from '~/paraglide/messages'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '~/shared/ui/select'

const USUAL = 'usual'

export function vatLabel(treatment: TicketVatTreatment): string {
  switch (treatment) {
    case 'rate_20':
      return m.ticketsVat20()
    case 'rate_13':
      return m.ticketsVat13()
    case 'rate_10':
      return m.ticketsVat10()
    case 'exempt':
      return m.ticketsVatExempt()
  }
}

const TREATMENTS: TicketVatTreatment[] = ['rate_20', 'rate_13', 'rate_10', 'exempt']

/** The VAT on ticket invoices; with `usualLabel` it also offers to follow the usual one. */
export function VatSelect({
  value,
  placeholder,
  usualLabel,
  onChange,
}: {
  value: TicketVatTreatment | null
  placeholder?: string
  usualLabel?: string
  onChange: (next: TicketVatTreatment | null) => void
}) {
  return (
    <Select
      value={value ?? (usualLabel ? USUAL : '')}
      onValueChange={(next) => onChange(next === USUAL ? null : (next as TicketVatTreatment))}
    >
      <SelectTrigger aria-label={m.ticketsInvoiceVat()} className="w-auto min-w-44">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {usualLabel ? <SelectItem value={USUAL}>{usualLabel}</SelectItem> : null}
        {TREATMENTS.map((treatment) => (
          <SelectItem key={treatment} value={treatment}>
            {vatLabel(treatment)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
